import { Col, Offcanvas, Row } from "react-bootstrap";
import { useEffect, useState } from "react";
import { RashiChart } from "../App/Basic/RashiChart";
import { axiosGetWithHeader } from "../Common/axios";

export function ChartOffCanvas({showpopup,handlePopup,userData, clientData}){
  const [position, setPosition] = useState('end');
  const handlePosition = ()=>setPosition(position==='end'?'start':'end');
  const [birthChartType, setBirthChartType] = useState('0');
  const [birthHouseData, setBirthHouseData] = useState([]);

  useEffect(() => {
    axiosGetWithHeader("/chart/birthchart/"+userData.id,
      (response)=>{
        setBirthHouseData(response.data.house);
        setBirthChartType(response.data.birthChartType);
      },
      (error)=>{
        console.log(error);
        setBirthHouseData(null);
        setBirthChartType(null);
      }
    );
  }, [userData]);
  
  return (
    <> 
      <Offcanvas show={showpopup} onHide={handlePopup} placement={position} backdrop={false} style={{opacity: 1.0,"overflow-y": "auto"}}>
        <Offcanvas.Header class="m-0 p-0" closeButton>
          <Offcanvas.Title class="w-100">
            <table class="w-100">
              <tr>
                <td class="text-start"><h5>Natal Chart</h5></td>
                <td class="text-end"><button type="button" class="btn btn-outline-primary" onClick={handlePosition}>{position==='end'?'<- Left':'Right ->'}</button></td>
              </tr>
            </table>
            </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body class="m-0 p-0">
          <Row id="birthChart" className="m-0 p-0">
            <Col xs={12} md={12} className="p-2 pt-0 m-0">
              { birthHouseData===null || birthHouseData===undefined || birthHouseData.length===0?<></>:
              <RashiChart birthHouseData={birthHouseData} userData={userData} clientData={clientData} birthChartType={birthChartType} setBirthChartType={setBirthChartType} kpenabled={true}/>
              }
            </Col>
          </Row>  
        </Offcanvas.Body>
      </Offcanvas>        
    </>
  );
}